:host{display:flex;flex-direction:row;flex:1;scroll-behavior:smooth;-ms-overflow-style:none;scrollbar-width:none}:host::-webkit-scrollbar{display:none}.content{display:flex;flex-direction:row;flex:1;overflow:visible}
/*# sourceMappingURL=scroll.component-4JJA35BJ.css.map */
